// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import CollabRow from './CollabRow'
import { useRemoveCollaborator, useUpdateCollaborator } from 'hooks/users/mutations';
import HelpLink from './HelpLink'

function CollabModalTeam(props) {
  const removeCollaboratorMutation = useRemoveCollaborator();
  const updateCollaboratorMutation = useUpdateCollaborator();

  const removeCollaborator = (e, collaboratorID) => {
    e.preventDefault();
    removeCollaboratorMutation.mutate({
      projectId: props.projectID,
      collaboratorId: collaboratorID
    });
  };

  const updateCollaborator = (collaboratorID, role) => {
    updateCollaboratorMutation.mutate({
      projectId: props.projectID,
      collaboratorId: collaboratorID,
      role
    });
  };

  const nextPage = (e) => {
    props.nextPage();
    e.preventDefault();
  };

  const collaboratorInfo = (props.collaborators ? props.collaborators : []).sort((a, b) => {
    return (a?.name || a?.email).localeCompare(b?.name || b?.email);
  });

  const collaborators = collaboratorInfo.map((collaborator) => {
    return <CollabRow
      key={collaborator.id}
      collaborator={collaborator}
      removeCollaborator={removeCollaborator}
      updateCollaborator={updateCollaborator}
      myRole={props.myRole}
      isSubscriptionOwner={props.isSubscriptionOwner}
      onActivateSubscription={props.onActivateSubscription}
      isRemoving={removeCollaboratorMutation.isPending}
      isUpdating={updateCollaboratorMutation.isPending}
    />
  });

  return (
    <div style={{marginTop: '10px'}}>
        {props.owner &&
          <div style={{padding:'15px 30px'}}>
            <div style={{width:"68%", float:"left"}}>
              {props.owner.name || props.owner.email}
              </div>
              <div style={{width:"32%", float:"left", paddingLeft:'40px'}}>
                Owner
              </div>
            <div style={{clear:"both"}}></div>
          </div>
        }
        {collaborators}

        <div style={{display:'flex', marginTop: '20px', marginLeft: "30px"}}>
          {process.env['INTERCOM_ARTICLE_SHARING'] && 
            <div style={{marginRight: '10px'}}>
              <HelpLink intercomArticle={process.env['INTERCOM_ARTICLE_SHARING']}>
                How does sharing work?
              </HelpLink>
            </div>
          }
          {process.env['INTERCOM_ARTICLE_COLLABORATION'] &&
            <div style={{marginLeft: '10px'}}>
              <HelpLink
                intercomArticle={process.env['INTERCOM_ARTICLE_COLLABORATION']}
                glyph="book"
              >
                Learn about collaboration
              </HelpLink>
            </div>
          }
        </div>
    </div>
  );
}

export default CollabModalTeam;
